import React from "react";
import { Position, Toast, OverlayToaster } from "@blueprintjs/core";
import { connect } from "react-redux";
import { getNotifications } from '../../store/ui_notifications/selectors';
import { removeNotification } from '../../store/ui_notifications/creators';
import { Translate } from "react-redux-i18n";

const notifications_types = {
    success: "bp3-intent-success",
    warning: "bp3-intent-warning",
    error: "bp3-intent-danger",
    general: "bp3-intent-primary"
}
let test_key = 0;
const Notification = (notification, callback) => {
    let params = {
        key: test_key++,
        className: notifications_types[notification.type],
        message: <Translate value={notification.message} />,
        onDismiss: () => callback(notification)
    }

    return <Toast {...params} />
}

class NotificationsToaster extends React.Component {
    toaster = OverlayToaster;
    refHandlers = {
        toaster: (ref) => this.toaster = ref,
    };

    onDismiss = (notification) => {
        this.props.removeNotification(notification);
    }

    render() {
        return (

            <OverlayToaster usePortal={false} className="notifications-toaster" position={Position.BOTTOM_LEFT} ref={this.refHandlers.toaster} >
                {/* "Toasted!" will appear here after clicking button. */}
                {this.props.notifications.map(notification => Notification(notification, this.onDismiss))}
            </OverlayToaster>

        )
    }
}
const mapStateToProps = state => ({
    locale: state.i18n.locale,
    notifications: getNotifications(state)
});

const mapDispatchToProps = dispatch => ({
    removeNotification: notification => dispatch(removeNotification(notification))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationsToaster);
